module.exports = __webpack_public_path__ + "img/hbg_export.9bd8d562.png";